import axiosPrivateMl from "./axiosPrivateMl"

export const getResolvedDeeplinks = async (requestData) => {
  return axiosPrivateMl.post(`/resolve_deeplinks`, { urls: requestData })
}
